import { render } from "./OurStory.vue?vue&type=template&id=28c2555c&scoped=true&ts=true"
import script from "./OurStory.vue?vue&type=script&lang=ts"
export * from "./OurStory.vue?vue&type=script&lang=ts"

import "./OurStory.vue?vue&type=style&index=0&id=28c2555c&scoped=true&lang=css"

import exportComponent from "/builds/otto-tech/otto-financas-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28c2555c"]])

export default __exports__